import { Metric } from 'modules/productAnalytics/types';
import {
  MetricDefinition,
  MetricDefinitionsBySendAction,
  MetricNamesBySendAction,
} from 'modules/workflows/types';
import { BaseOption } from 'ui/selects';
import { DROPDOWNS_LIST } from './Metrics.constants';

type OptionsByMedium = Record<string, BaseOption[]>;

const getOptionsByMedium = (metric: Metric, options: OptionsByMedium) =>
  metric.mediums.reduce((acc, medium) => {
    const option = {
      categoryId: metric.category || '',
      id: metric.metricName,
      label: metric.metricNiceName,
      value: metric.metricName,
    };

    return {
      ...acc,
      [medium]: [...(acc[medium] || []), option],
    };
  }, options);

export const getOptionsAndCategories = (
  analyticsMetrics: Metric[],
): {
  categories: Record<string, string | number>;
  options: OptionsByMedium;
} =>
  analyticsMetrics.reduce(
    (acc, metric) => {
      const { category } = metric;

      return {
        options: getOptionsByMedium(metric, acc.options),
        categories: { ...acc.categories, ...(category && { [category]: category }) },
      };
    },
    {
      categories: {},
      options: {},
    },
  );

export const getDefaultTileMetrics = (
  tileMetrics: MetricDefinitionsBySendAction,
): MetricNamesBySendAction =>
  DROPDOWNS_LIST.reduce((acc, { actionName }) => {
    const selectedMetrics = tileMetrics[actionName];

    return {
      ...acc,
      [actionName]: selectedMetrics?.length
        ? selectedMetrics?.map((m: MetricDefinition) => m.metricName)
        : [],
    };
  }, {});
